import * as React from 'react';

import { Link, Typography2 } from '@coursera/cds-core';
import { SvgChevronRight } from '@coursera/coursera-ui/svg';

import type { XdpDataQuery_XdpV1Resource_slug_elements_xdpMetadata_XdpV1_cdpMetadataMember_cdpMetadata_courseTypeMetadata as CourseTypeMetadata } from 'bundles/accomplishments/components/course-certificates/__generated__/XdpDataQuery';

import _t from 'i18n!nls/accomplishments';

type Props = {
  name: string;
  includeGrade?: boolean;
  isSpecialization?: boolean;
  ownRecord?: boolean;
  courseTypeMetadata?: CourseTypeMetadata | null;
};

const PageHeader = ({ includeGrade, ownRecord, name, isSpecialization = false, courseTypeMetadata }: Props) => {
  const productTypeLabel = courseTypeMetadata?.__typename === 'XdpV1_projectMember' ? _t('Project') : _t('Course');
  const certificate = _t('#{productTypeLabel} Certificate', { productTypeLabel });
  return (
    <div className="accomplishment-page-header">
      <Typography2 className="certificate-type" component="nav" aria-label={_t('Breadcrumb')} variant="bodySecondary">
        {includeGrade || ownRecord ? (
          <div>
            {isSpecialization ? (
              _t('Accomplishments')
            ) : (
              <Link data-testid="accomplishments-link" href="/accomplishments">
                {_t('Accomplishments')}
              </Link>
            )}
            <SvgChevronRight
              size={14}
              color="var(--cds-color-neutral-primary)"
              suppressTitle={true}
              style={{
                marginLeft: '9px',
                marginRight: '9px',
              }}
            />
            <span className="private" aria-current="page">
              {isSpecialization ? _t('Specialization Certificate') : certificate}
            </span>
          </div>
        ) : (
          <span aria-current="page">{isSpecialization ? _t('Specialization Certificate') : certificate}</span>
        )}
      </Typography2>
      <h2 className="course-name">{name}</h2>
    </div>
  );
};

export default PageHeader;
